import { render } from "./PullToRefresh.vue?vue&type=template&id=2a6d189a&scoped=true"
import script from "./PullToRefresh.vue?vue&type=script&lang=js"
export * from "./PullToRefresh.vue?vue&type=script&lang=js"

import "./PullToRefresh.vue?vue&type=style&index=0&id=2a6d189a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6d189a"]])

export default __exports__